/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import camelcaseKeys from 'camelcase-keys';
import Cleave from 'cleave.js/react';
import React, { useEffect, useState } from 'react';
import { Card, Row } from 'react-bootstrap';
import SyncLoader from 'react-spinners/SyncLoader';
// import MoonLoader from 'react-spinners/MoonLoader';
import * as Sentry from '@sentry/node';
import { FranchiseeState } from '../../context/Franchisee/franchisee.types';
import StorePickerCard from '../StorePickerCard';
// import Gataware from '../../SDKs/Gataware';
import axios, { AxiosResponse } from 'axios';
import useSWR from 'swr';
import { duplicateRequest } from '../../data/revalidate';
import { pink500 } from '../../ui/colors';
import { validateZipCode } from '../../utils/stringValidation';

interface StorePickerProps {
  onSelect?: Function;
  show: boolean;
}

// const sortStores = (storeA, storeB) => {
//   if (storeA.state > storeB.state) return 1;
//   if (storeA.state < storeB.state) return -1;
//   if (storeA.name > storeB.name) return 1;
//   if (storeA.name < storeB.name) return -1;
//   return 0;
// };

const StorePicker: React.FC<StorePickerProps> = ({
  onSelect,
  show,
}: StorePickerProps) => {
  const [searchString, setSearchString] = useState<string>('');
  const [franchisees, setFranchisees] = useState<Array<FranchiseeState>>([]);
  // saved full results for if the use doesn't get any stores from their zipCode
  const [franchiseesStore, setFranchiseesStore] = useState<
    Array<FranchiseeState>
  >([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [initialLoading, setInitialLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<boolean>(false);
  const [networkError, setNetworkError] = useState<boolean>(false);

  const { data: locations, error } = useSWR('/api/get-locations/', {
    dedupingInterval: duplicateRequest,
  });

  useEffect(() => {
    if (show && franchiseesStore.length < 1) {
      setInitialLoading(true);
      if (locations) {
        const filteredFranchisee = locations.data.filter(
          (franchisee) =>
            !franchisee.slug.includes('corporate') &&
            // !franchisee.slug.includes('training') &&
            !franchisee.slug.includes('client')
        );
        const franchiseeData = filteredFranchisee
          .map((franchisee) => camelcaseKeys(franchisee)).sort((a, b) => a.name.localeCompare(b.name));
        setFranchisees(franchiseeData);
        setFranchiseesStore(franchiseeData);
        setInitialLoading(false);
      } else if (error) {
        setInitialLoading(false);
        setNetworkError(true);
      }
    }
  }, [show]);

  useEffect(() => {
    if (validateZipCode(searchString)) {
      setLoading(true);
      // axios
      //   .post('/api/search-zip-code', { searchZipCode: searchString })
      //   .then((result) => console.log(result.data))
      //   .catch((e) => console.log(e));

      axios
        .post('/api/get-franchisee-by-zone-zip-code/', { zipCode: searchString })
        .then(({ data, status }: AxiosResponse) => {
          setFranchisees([]);
          if (status === 200) {
            const franchiseeData = data.data.map((franchisee) =>
              camelcaseKeys(franchisee)
            ).sort((a, b) => a.name.localeCompare(b.name));;
            setFranchisees(franchiseeData);
            setErrorMessage(false);
          } else if (status === 502) {
            setInitialLoading(false);
            setNetworkError(true);
          }
          if (data.data === undefined || data.data.length < 1) {
            axios.post('/api/get-locations/', {
              zipCode: searchString,
            }).then(res => {
              // console.log('The res data is: ', res.data.data)
              if (res.data.data && res.data.data.length > 0) {
                let franchiseeData = res.data.data.map((franchisee) =>
                camelcaseKeys(franchisee)
              ).sort((a, b) => a.name.localeCompare(b.name));;
                setFranchisees(franchiseeData);
                setErrorMessage(false);
              } else {
                setErrorMessage(true);
                return;
              }
          })
        }})
        .catch((error) => {
          Sentry.captureException(error);
        })
        .finally(() => setLoading(false));
    } else if (franchisees.length !== franchiseesStore.length) {
      setFranchisees(franchiseesStore);
    }
  }, [searchString]);

  return (
    <>
      {/* Add store picker Content Here */}
      {}
      <div className='px-3 py-2 store-picker-top' style={{ marginTop: '12rem' }}>
        <label
          className='h4 text-left mb-3 d-flex justify-content-between store-picker-title'
          htmlFor='zipcode-input'
        >
          Select a Store{' '}
          <SyncLoader color={pink500} size={5} loading={loading} />
        </label>
        <Cleave
          id='zipcode-input'
          name='zipcode-input'
          className='form-control'
          placeholder='Zip Code'
          type='tel'
          options={{ numericOnly: true }}
          maxLength={5}
          value={searchString}
          autoComplete='postal-code'
          onChange={(e) => {
            setSearchString(e.currentTarget.value);
          }}
        />
      </div>
      <div className='scroll-wrapper'>
        {initialLoading && (
          <SyncLoader
            color={pink500}
            size={7}
            loading={initialLoading}
            css='display: flex;
            justify-content: center;
            height: 84%;
            align-items: center;'
          />
        )}
        {franchisees.map((franchisee) => (
          <StorePickerCard
            zipCodeInput={searchString}
            value={franchisee}
            onSelect={onSelect}
            key={`franchisee-${franchisee.slug}`}
            source={'storepicker'}
          />
        ))}
        {networkError && (
          <Card bsPrefix='store-picker-card'>
            <Card.Body className='p-3 '>
              <h5 className='h5 mb-2'>502 Bad Gateway</h5>
              <Row className='px-3 mb-2'>
                <p>
                  There seems to be a network issue. This request cannot be
                  completed at this time.
                </p>
                <br />
              </Row>
            </Card.Body>
          </Card>
        )}

        {errorMessage && (
          <Card bsPrefix='store-picker-card'>
            <Card.Body className='p-3 '>
              <h5 className='h5 mb-2'>No Location Found</h5>
              <Row className='px-3 mb-2'>
                <p>
                  Unfortunately, your zip code is not currently in our service area. We are growing and hope to service your area in the future, so please check back with us.
                </p>
                <br />
              </Row>
            </Card.Body>
          </Card>
        )}
      </div>
    </>
  );
};

StorePicker.defaultProps = {
  // add store picker default props here
  onSelect: () => {},
};

const MemoizedStorePicker = React.memo(StorePicker);
export default MemoizedStorePicker;
